export default __webpack_public_path__ + "static/media/arrowBack.0ae80791.svg";